import React, { Component, useState } from 'react';
import { useGetCompanyListMinimal } from '../../hooks/useCompanies';
import style from './index.module.css';
import { Select, Row, Col, Tag } from 'antd';
import stl from 'string-to-color';

export default function CompanyDropdown({ onChange = () => {} }) {
    const [selectedCompanies, setSelectedCompanies] = useState([]);
    const { data: companies, isFetching: isFetchingcompanies, isFetched: isFetchedcompanies, refetch: refetchcompanies } = useGetCompanyListMinimal();

    return (
        <>
            <div>
                <Select
                    loading={isFetchingcompanies}
                    mode="single"
                    style={{
                        minWidth: 300,
                    }}
                    allowClear
                    className={style.select}
                    placeholder={'Select Company'}
                    value={selectedCompanies}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ minWidth: '330px' }}
                    size="small"
                    options={companies?.map(company => {
                        return {
                            label: (
                                <>
                                    <Row>
                                        <Col
                                            flex="60px"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                            }}
                                        >
                                            <Tag color={stl(company?.code)}>{company?.code}</Tag>
                                        </Col>
                                        <Col flex="auto" style={{}}>
                                            {company?.name}
                                        </Col>
                                    </Row>
                                </>
                            ),
                            searchBy: `${company?.code} ${company?.name}`,
                            value: company?.code,
                            _id: company?._id,
                        };
                    })}
                    optionFilterProp="searchBy"
                    listItemHeight={10}
                    listHeight={550}
                    maxTagCount={1}
                    maxTagTextLength={10}
                    onChange={(value, item) => {
                        onChange(item);
                        setSelectedCompanies(value);
                    }}
                    onClear={() => setSelectedCompanies('')}
                    showSearch
                />
            </div>
        </>
    );
}
